module.exports = __webpack_public_path__ + "static/truff-family-71af8d81000b340b3b9f275157d159e5.jpg";